<script>
	import {External, M} from "../../external";
	import {ignore} from "../../Common/tools";
	import {onMount} from "svelte";
	import Loader from "../../Common/Loader.svelte";
	import {LmsUtils} from "../utils/LmsUtils";

	export let circles = [], onEnroll = ignore;
	let loading = true;
	let nonMemberCircles = [];

	let enroll = (circle) => {
		External.Tools.prompt("", External.format(M.ENROLL_MEMBER_QUESTION, 'x', circle.name), () => onEnroll(circle));
	};

	onMount(async () => {
		loading = true;
		let allCircles = (await LmsUtils.listCircles());//.filter(circle => circle.published);
		nonMemberCircles = allCircles.filter((circle) => circle.id && circles.filter(memberCircleDetails => memberCircleDetails.circle.id === circle.id).length === 0)
		loading = false;
	});

</script>

<div class="popup-widget-wrapper">
	<div class="col20 f-left t-center mt-15">
		<span class="material-icons-outlined fingerprint-icon"> hdr_weak </span>
	</div>
	<h4 class="col20 f-left mt-15 mb-10 t-center h4-bigger">{M.CIRCLE_MANAGEMENT}</h4>
	<span class="light-gray-text t-center col20 f-left mb-10 padded-text">{M.CIRCLE_MANUALLY_ASSIGN}</span>
	{#if loading}
		<Loader />
	{:else}
		<div class="col20 f-left mt-25">
			{#if nonMemberCircles.length === 0}
				<div class="circle-management-wrapper col20 f-left flex align-center space-between mb-5">
					<p style="margin: 0 auto;">{M.MEMBER_IN_ALL_CIRCLES}</p>
				</div>
			{:else}
				{#each nonMemberCircles as circle}
					<div class="circle-management-wrapper col20 f-left flex align-center space-between mb-5">
						<h4>{circle.name}</h4>
						<a on:click={() => enroll(circle)} class="middle-button blue with-icon">{M.ADD}</a>
					</div>
				{/each}
			{/if}
		</div>
	{/if}
</div>
